<template>
  <div class="vacancies wc bg-white">
    <!--    <slide-up-down :active="view_more" :duration="500" -->
    <div class="vacancies__wrapper container">
      <div class="vacancies__ttl-wrapper flex j_sb a_center">
        <h2 class="vacancies__ttl f-24 bold uppercase">{{ main_title }}</h2>
        <router-link
          :to="get_vacancies_url"
          class="f-14 medium f-light-purple uppercase"
          >{{ $fn.tr("მაჩვენე ყველა") }}</router-link
        >
      </div>
      <div
        class="vacancies__cards  grid"
        v-if="content.length > 6 && content.length !== 6"
      >
        <div
          class="vacancies__card flex column br-12 bg-white wc"
          v-for="(card, index) in content_less"
          :key="index"
        >
          <transition name="fade2">
            <div
              class="vacancies__card--view_more flex a_center j_center column br-12 bg-white wc pointer pos_abs"
              :class="{ collapsed: view_more }"
              v-if="!view_more && index == 5"
              @click="collapse()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="55.17"
                height="55.17"
                viewBox="0 0 55.17 55.17"
              >
                <path
                  id="Combined_Shape_Copy_3"
                  data-name="Combined Shape Copy 3"
                  d="M17.206.952a3.251,3.251,0,0,0,0,4.6L27.912,16.254H3.25a3.251,3.251,0,0,0,0,6.5H27.909l-10.7,10.7a3.25,3.25,0,0,0,4.6,4.6L38.058,21.8l.056-.057.027-.029.027-.029.033-.037.019-.022.036-.043.014-.017.038-.047.011-.014.038-.05.009-.012.037-.051.009-.013.035-.051.01-.015.032-.049.012-.019.028-.045.015-.025.023-.039.019-.034.017-.031.024-.045.011-.021.03-.058,0-.007a3.25,3.25,0,0,0-.667-3.786L21.8.952a3.251,3.251,0,0,0-4.6,0Z"
                  transform="translate(27.585) rotate(45)"
                  fill="#7063e9"
                />
              </svg>
              <span
                class="bold f-14 f-light-purple uppercase"
                v-if="!view_more"
                >{{ $fn.tr("მაჩვენე მეტი") }}</span
              >
              <span class="bold f-14 f-light-purple uppercase" v-else>{{
                $fn.tr("მაჩვენე ნაკლები")
              }}</span>
            </div>
          </transition>
          <div class="vacancies__card--city">
            <span class="f-14 medium">{{ card.location_full[0].title }}</span>
          </div>

          <h2 class="f-24 bold vacancies__card--ttl uppercase">
            {{ card.title }}
          </h2>
          <router-link
            :to="
              get_vacancies_url +
                '/' +
                'singleview/' +
                card.id +
                '-' +
                card.slug
            "
            class="vacancies__card--cta flex a_center button bg-light-purple"
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="11.352"
              height="11.351"
              viewBox="0 0 11.352 11.351"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-14 bold f-white uppercase">{{
              $fn.tr("Vacancies Cards cta title")
            }}</span>
          </router-link>
        </div>
      </div>
      <div class="vacancies__cards  grid" v-else>
        <div
          class="vacancies__card flex column br-12 bg-white wc"
          v-for="(card, index) in content"
          :key="index"
        >
          <div class="vacancies__card--city">
            <span class="f-14 medium">{{ card.location_full[0].title }}</span>
          </div>

          <h2 class="f-24 bold vacancies__card--ttl uppercase">
            {{ card.title }}
          </h2>
          <router-link
            :to="
              get_vacancies_url +
                '/' +
                'singleview/' +
                card.id +
                '-' +
                card.slug
            "
            class="vacancies__card--cta flex a_center button bg-light-purple"
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="11.352"
              height="11.351"
              viewBox="0 0 11.352 11.351"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-14 bold f-white uppercase">{{
              $fn.tr("Vacancies Cards cta title")
            }}</span>
          </router-link>
        </div>
      </div>

      <slide-up-down
        :active="view_more"
        :duration="500"
        class="vacancies__cards vacancies__cards--collapsed"
        v-if="content.length > 6 && content.length !== 6"
      >
        <div
          class="vacancies__cards--collapsed__wrapper grid"
          :class="{ show_cards: show_cards }"
        >
          <div
            class="vacancies__card flex column br-12 bg-white wc"
            v-for="(card, index) in content_more"
            :key="index"
          >
            <div class="vacancies__card--city">
              <span class="f-14 medium">{{ card.location_full[0].title }}</span>
            </div>

            <h2 class="f-24 bold vacancies__card--ttl uppercase">
              {{ card.title }}
            </h2>
            <router-link
              :to="
                get_vacancies_url +
                  '/' +
                  'singleview/' +
                  card.id +
                  '-' +
                  card.slug
              "
              class="vacancies__card--cta flex a_center button bg-light-purple"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#fff"
                />
              </svg>
              <span class="f-14 bold f-white uppercase">{{
                $fn.tr("Vacancies Cards cta title")
              }}</span>
            </router-link>
          </div>

          <div
            class="vacancies__card--view_more flex a_center j_center column br-12 bg-white wc pointer"
            @click="collapse()"
          >
            <svg
              :class="{ view_more: view_more }"
              xmlns="http://www.w3.org/2000/svg"
              width="55.17"
              height="55.17"
              viewBox="0 0 55.17 55.17"
            >
              <path
                id="Combined_Shape_Copy_3"
                data-name="Combined Shape Copy 3"
                d="M17.206.952a3.251,3.251,0,0,0,0,4.6L27.912,16.254H3.25a3.251,3.251,0,0,0,0,6.5H27.909l-10.7,10.7a3.25,3.25,0,0,0,4.6,4.6L38.058,21.8l.056-.057.027-.029.027-.029.033-.037.019-.022.036-.043.014-.017.038-.047.011-.014.038-.05.009-.012.037-.051.009-.013.035-.051.01-.015.032-.049.012-.019.028-.045.015-.025.023-.039.019-.034.017-.031.024-.045.011-.021.03-.058,0-.007a3.25,3.25,0,0,0-.667-3.786L21.8.952a3.251,3.251,0,0,0-4.6,0Z"
                transform="translate(27.585) rotate(45)"
                fill="#7063e9"
              />
            </svg>
            <span
              class="bold f-14 f-light-purple uppercase"
              v-if="!view_more"
              >{{ $fn.tr("მაჩვენე მეტი") }}</span
            >
            <span class="bold f-14 f-light-purple uppercase" v-else>{{
              $fn.tr("მაჩვენე ნაკლები")
            }}</span>
          </div>
        </div>
      </slide-up-down>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  mixins: [resize_handler],
  props: ["contentData"],
  data() {
    return {
      view_more: false,
      show_cards: false
    };
  },

  computed: {
    main_title() {
      return _.get(this.contentData, "conf.header.title");
    },

    get_vacancies_url() {
      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter(m => m.configs.includes("vacancies"));
      return menus[0].full_url;
    },
    content() {
      let data = _.get(this.contentData, "data.list");
      let locs = this.$store.state.main.indx.terms.location;
      let new_locs;

      for (let j = 0; j < data.length; j++) {
        data[j].location_full = locs.filter(
          loc => loc.id == data[j].location[0]
        );
      }
      return data;
    },
    content_less() {
      return this.content.slice(0, 6);
    },
    content_more() {
      return this.content.slice(6);
    },
    conf() {
      return _.get(this.contentData, "conf.conf[0]");
    }
  },
  methods: {
    collapse() {
      if (this.view_more == false) {
        this.view_more = !this.view_more;
        this.$store.state.main.trigger_update = !this.$store.state.main
          .trigger_update;
      } else {
        this.show_cards = false;
        setTimeout(() => {
          this.view_more = !this.view_more;
          this.$store.state.main.trigger_update = !this.$store.state.main
            .trigger_update;
        }, 300);
      }
    }
  },
  watch: {
    view_more(ns, os) {
      if (ns == true) {
        setTimeout(() => {
          this.show_cards = true;
        }, 400);
      }
    }
  }
};
</script>

<style></style>
